













































































































































































































































































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import ColorPicker from '@/web/components/settings/ColorPicker';
import DirtyMixin from '@/web/mixins/DirtyMixin';
import BrandingStudioFontModal from '@/web/components/settings/BrandingStudioFontModal.vue';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';
import { isBrightColor } from '@/web/utils/colors.js';
import templates from '@/web/utils/studio-templates';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';

export default Vue.extend({
  name: 'Branding',
  mixins: [DirtyMixin, TeacherPermissionsMixin],
  components: {
    TopNav,
    NavItem,
    ColorPicker,
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
      teacherMagicCode: 'user/teacherMagicCode',
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherProducts: 'product/teacherProducts',
    }),
    selectedFeaturedProduct: {
      get() {
        return this.products.find(
          product => product.id === this.teacherModel.featured_product
        );
      },
      set(value) {
        this.teacherModel.featured_product = value.id;
      },
    },
    products() {
      return (this.teacherProducts || [])
        .filter(product => product.published)
        .filter(product => !product.parent_product);
    },
    tabs() {
      return [
        { name: 'assets', title: this.$t('SETTINGS.LABEL.ASSETS') },
        { name: 'templates', title: this.$t('SETTINGS.LABEL.TEMPLATES') },
        { name: 'text', title: this.$t('SETTINGS.LABEL.TEXT') },
        { name: 'links', title: this.$t('SETTINGS.LABEL.LINKS') },
        { name: 'code_embed', title: this.$t('SETTINGS.LABEL.CODE_EMBED') },
      ];
    },
    defaultFontLabel() {
      if (!this.teacherModel?.default_font) {
        return;
      }
      const selectedFont = this.teacherModel.available_fonts.find(
        font => font.value === this.teacherModel.default_font
      );
      return selectedFont.label;
    },
    templates() {
      return templates;
    },
    exampleMedia() {
      return {
        id: 12990,
        media: {
          id: 24678,
          video_url: '',
          thumbnail: null,
          thumbnail_video: null,
          thumbnail_storage: null,
          storage_url: null,
          file_name: 'Zoom Recording',
          file_type: 'recording',
          file_content: 'video',
          width: null,
          height: null,
          file_size: 821767,
          video_length: 3900,
          uploaded: '2019-02-14T22:00:44.199766Z',
          locked: false,
          playback_start: 0,
          playback_end: 13,
          embedded_image_url: null,
          embedded_thumbnail_url: null,
        },
        options: [],
        title: "Recording - LS from Sandy's account",
      };
    },
    customLabelTooLong() {
      if (
        this.teacherModel?.custom_nav_label_1?.length > 16 ||
        this.teacherModel?.custom_nav_label_2?.length > 16 ||
        this.teacherModel?.custom_nav_label_3?.length > 16
      ) {
        return true;
      }
      return false;
    },
    customLinkEmpty() {
      if (
        (this.teacherModel?.custom_nav_label_1?.length &&
          !this.teacherModel?.custom_nav_link_1) ||
        (this.teacherModel?.custom_nav_label_2?.length &&
          !this.teacherModel?.custom_nav_link_2) ||
        (this.teacherModel?.custom_nav_label_3?.length &&
          !this.teacherModel?.custom_nav_link_3)
      ) {
        return true;
      }
      return false;
    },
    customLabelEmpty() {
      if (
        (this.teacherModel?.custom_nav_link_1?.length &&
          !this.teacherModel?.custom_nav_label_1) ||
        (this.teacherModel?.custom_nav_link_2?.length &&
          !this.teacherModel?.custom_nav_label_2) ||
        (this.teacherModel?.custom_nav_link_3?.length &&
          !this.teacherModel?.custom_nav_label_3)
      ) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      selectedTab: 'assets',
      placeholderText: 'https://',
      teacherModel: null,
      inProgress: false,
      isTooBright: false,
      productsLoading: true,
    };
  },
  methods: {
    previewTemplate(template) {
      const url = getStudentViewURL(
        this.teacherStudioUrl,
        `/?preview_template=${template.id}`,
        this.teacherMagicCode
      );
      window.open(url, '_blank');
    },
    setPrimaryColor(color) {
      this.teacherModel.primary_color = color;
    },
    resetTeacherModel() {
      this.teacherModel = cloneDeep(this.teacher);
    },
    removeLogo() {
      this.teacherModel.logo = null;
    },
    removeCoverPhoto() {
      this.teacherModel.cover_photo = null;
    },
    removeProfilePhoto() {
      this.teacherModel.profile_photo = null;
    },
    removeWelcomeVideo() {
      this.teacherModel.welcome_video = null;
    },
    openSelectFontModal() {
      this.$modal.show(
        BrandingStudioFontModal,
        {
          fonts: this.teacherModel.available_fonts,
          selectedFont: this.teacherModel.default_font,
        },
        null,
        { 'before-close': this.setSelectedFont }
      );
    },
    setSelectedFont($event) {
      if (!$event.params) {
        return;
      }
      this.teacherModel.default_font = $event.params;
    },
    async updateTeacher() {
      if (this.inProgress) {
        return;
      }
      this.inProgress = true;
      try {
        if (this.customLabelTooLong) {
          throw new Error(this.$tc('SETTINGS.TEXT.CUSTOM_NAV_LABEL_TOO_LONG'));
        }
        if (this.customLinkEmpty) {
          throw new Error(this.$tc('SETTINGS.TEXT.CUSTOM_NAV_LINK_EMPTY'));
        }
        if (this.customLabelEmpty) {
          throw new Error(this.$tc('SETTINGS.TEXT.CUSTOM_NAV_LABEL_EMPTY'));
        }
        const teacherModel = cloneDeep(this.teacherModel);
        if (teacherModel.logo?.id) {
          teacherModel.logo = teacherModel.logo.id;
        }
        if (teacherModel.cover_photo?.id) {
          teacherModel.cover_photo = teacherModel.cover_photo.id;
        }
        if (teacherModel.about_photo?.id) {
          teacherModel.about_photo = teacherModel.about_photo.id;
        }
        if (teacherModel.profile_photo?.id) {
          teacherModel.profile_photo = teacherModel.profile_photo.id;
        }
        if (teacherModel.welcome_video?.id) {
          teacherModel.welcome_video = teacherModel.welcome_video.id;
        }
        if (teacherModel.app_icon?.id) {
          teacherModel.app_icon = teacherModel.app_icon.id;
        }
        if (teacherModel.favicon?.id) {
          teacherModel.favicon = teacherModel.favicon.id;
        }
        const dispatchPromise = await this.$store.dispatch(
          'user/updateTeacher',
          {
            teacher: teacherModel,
          }
        );
        this.$emit('onSubmit', dispatchPromise);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('SETTINGS.NOTIFICATIONS.UPDATE_BRANDING_SUCCESS'),
        });
        this.$store.dispatch('globals/setDirty', false);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('SETTINGS.NOTIFICATIONS.UPDATE_BRANDING_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
    labelRules(customLink) {
      return customLink?.length ? 'max:16|required' : 'max:16';
    },
    linkRules(customLabel) {
      return customLabel?.length ? 'required' : '';
    },
    profilePhotoChanged(file) {
      let image = null;
      if (file) {
        image = file.thumbnail ? file.thumbnail : file.storage_url;
      }
      this.$store.dispatch('community/saveMyCommunityProfileData', {
        image,
        is_studio: true,
      });
    },
  },
  watch: {
    teacher() {
      this.resetTeacherModel();
    },
    teacherModel: {
      handler: function (teacherModel, oldTeacherModel) {
        this.isTooBright = isBrightColor(this.teacherModel.primary_color);

        if (oldTeacherModel) {
          this.setDirty();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.resetTeacherModel();
    this.$store.dispatch('product/getTeacherProducts').then(() => {
      this.productsLoading = false;
    });
    if (this.$route.query.tab) {
      this.selectedTab = this.$route.query.tab;
      // check if selected tab is valid in array from tabs()
      if (!this.tabs.find(tab => tab.name === this.selectedTab)) {
        this.selectedTab = this.tabs[0].name;
      }
    }
  },
});
